import { hoverTooltip } from '@codemirror/view';
import { TOOLTIP_MESSAGES } from './shared/tooltipMessages.js';

/**
 * Creates a unified tooltip for ambiguous term errors.
 * This handles both child term article errors and parent term warnings,
 * displaying the same helpful message for both.
 */
export function createAmbiguousTermTooltip() {
    return hoverTooltip((view, pos, _side) => {
        // Check if we're hovering over an ambiguous term element
        const element = view.domAtPos(pos);
        if (!element || !element.node) return null;
        
        // Walk up the DOM to find an element with ambiguous term class
        let currentElement = element.node.nodeType === Node.TEXT_NODE ? element.node.parentElement : element.node;
        
        while (currentElement && currentElement !== view.dom) {
            // Check if this element has the ambiguous term class
            if (currentElement.classList?.contains('cm-ambiguous-term')) {
                const errorInfo = {
                    errorType: currentElement.getAttribute('data-error-type'),
                    message: currentElement.getAttribute('data-message') || TOOLTIP_MESSAGES.AMBIGUOUS_TERM_ERROR,
                    term: currentElement.getAttribute('data-term'),
                    expected: currentElement.getAttribute('data-expected'),
                    context: currentElement.getAttribute('data-context'),
                    source: currentElement.getAttribute('data-source') // For debugging
                };
                
                // Create tooltip content
                const dom = document.createElement('div');
                dom.className = 'cm-ambiguous-term-tooltip';
                
                const message = document.createElement('div');
                message.className = 'tooltip-message';
                message.style.whiteSpace = 'pre-line'; // Preserve line breaks for the scenarios
                message.innerHTML = errorInfo.message;

                dom.appendChild(message);

                return {
                    pos: pos,
                    above: true,
                    create: () => ({ dom })
                };
            }
            currentElement = currentElement.parentElement;
        }

        return null;
    });
}

// CSS styles for the tooltip - using CSS variables from global.css
export const ambiguousTermTooltipStyles = `
.cm-ambiguous-term-tooltip {
    background: var(--color-ambiguous-term-error-bg);
    border: 1px solid var(--color-ambiguous-term-error);
    border-radius: 6px;
    padding: 8px 12px;
    box-shadow: 0 4px 12px var(--shadow-md);
    max-width: 500px;
    font-size: 14px;
    line-height: 1.3;
}

.cm-ambiguous-term-tooltip .tooltip-message {
    color: var(--color-ambiguous-term-error);
    margin-bottom: 4px;
}
`;